"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const accordion_1 = __importDefault(require("./accordion"));
const alert_1 = __importDefault(require("./alert"));
const appBar_1 = __importDefault(require("./appBar"));
const autocomplete_1 = __importDefault(require("./autocomplete"));
const bottomNavigation_1 = __importDefault(require("./bottomNavigation"));
const button_1 = __importDefault(require("./button"));
const checkbox_1 = __importDefault(require("./checkbox"));
const chip_1 = __importDefault(require("./chip"));
const container_1 = __importDefault(require("./container"));
const cssBaseline_1 = __importDefault(require("./cssBaseline"));
const dialog_1 = __importDefault(require("./dialog"));
const divider_1 = __importDefault(require("./divider"));
const form_1 = __importDefault(require("./form"));
const input_1 = __importDefault(require("./input"));
const linearProgress_1 = __importDefault(require("./linearProgress"));
const listItem_1 = __importDefault(require("./listItem"));
const menu_1 = __importDefault(require("./menu"));
const paper_1 = __importDefault(require("./paper"));
const popover_1 = __importDefault(require("./popover"));
const radio_1 = __importDefault(require("./radio"));
const select_1 = __importDefault(require("./select"));
const slider_1 = __importDefault(require("./slider"));
const svgIcon_1 = __importDefault(require("./svgIcon"));
const table_1 = __importDefault(require("./table"));
const tabs_1 = __importDefault(require("./tabs"));
const toggle_1 = __importDefault(require("./toggle"));
const toggleButton_1 = __importDefault(require("./toggleButton"));
const toolbar_1 = __importDefault(require("./toolbar"));
const tooltip_1 = __importDefault(require("./tooltip"));
const typography_1 = __importDefault(require("./typography"));
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
const ComponentsOverride = Object.assign({}, accordion_1.default, alert_1.default, appBar_1.default, autocomplete_1.default, bottomNavigation_1.default, button_1.default, checkbox_1.default, chip_1.default, container_1.default, cssBaseline_1.default, dialog_1.default, divider_1.default, form_1.default, input_1.default, linearProgress_1.default, listItem_1.default, menu_1.default, paper_1.default, popover_1.default, radio_1.default, select_1.default, slider_1.default, svgIcon_1.default, tabs_1.default, table_1.default, toggle_1.default, toggleButton_1.default, toolbar_1.default, tooltip_1.default, typography_1.default);
exports.default = ComponentsOverride;
